import * as yup from "yup";

export const VALIDATION_SCHEMA = yup.object({
  first_name: yup.string().required("This field is required!"),
  last_name: yup.string().required("This field is required!"),
  company_name: yup.string().required("This field is required!"),
  company_website: yup.string(),
});
